import BaseView from "./_BaseView.js";
import DOMPurify from "dompurify";

export default class SignupView extends BaseView {
    constructor() {
        super();
        this.domainTimeout = null;
        this.domainAjax = null;
    }

    setEvents() {
        super.setEvents();
        const self = this;

        if ($('#trial-signup').length > 0) {
            $('#trial-signup input[name="password"]').pwstrength();

            // $('input[name="org_name"]').on('keydown', function (e) {
            //     self.suggestDomain($(this));
            // });
            //
            // $('input[name="subdomain"]').on('keydown change', function (e) {
            //     if ($(this).val() !== '') {
            //         self.domainCheck($(this));
            //     }
            // });

            $('.agree-button').on('click', function () {
                const agreed = $('.agreed');
                if (agreed.prop('checked')) {
                    $('.agreement').slideUp();
                    $('.inputs').slideDown();
                    $(window).scrollTop(0);
                } else {
                    agreed.parents('label').addClass('aero-require-error');
                }
                return false;
            });

            $('#trial-signup').on('submit', function () {
                self.submitForm();
                return false;
            });

            setTimeout(function () {
                window.location.reload();
            }, 600000);
        }
    }

    // domainCheck($input) {
    //     const self = this;
    //     clearTimeout(this.domainTimeout);
    //
    //     if (this.domainAjax !== null) {
    //         this.domainAjax.abort();
    //     }
    //
    //     this.domainTimeout = setTimeout(function () {
    //         $('.subdomain-results').text('');
    //         $('.check-indicator').show();
    //         self.domainAjax = Api.send('/api/instance/check', {subdomain: $input.val()}).done(function (r) {
    //             if (r.taken === false) {
    //                 $input.parents('label').removeClass('aero-error');
    //                 $('.signup-submit').prop('disabled', false);
    //                 $('.subdomain-results').text(Lang.subdomainokay);
    //             } else {
    //                 $input.parents('label').addClass('aero-error');
    //                 $('.signup-submit').prop('disabled', true);
    //                 $('.subdomain-results').text(Lang.subdomaintaken);
    //             }
    //             $('.check-indicator').hide();
    //         });
    //     }, 200);
    // }
    //
    // suggestDomain($input) {
    //     let val = $input.val();
    //     val = val.toLowerCase().split(' ')[0];
    //     val = val.replace(/[^a-z]/g, '');
    //     $('input[name="subdomain"]').val(val).change();
    // }

    submitForm() {
        const form = $('#trial-signup');
        const data = form.aeroSerialize();
        const options = {
            type: 'post',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json',
            url: '/api/trial/signup'
        };

        $('.field-error-msg').remove();

        $.ajax(options)
            .done(function (r) {
                if ($('#sapForm').length > 0) {
                    window.top.location = '/concursuccess';
                } else {
                    window.top.location = `https://${r.url}?trial=1&t=${r.login_token}`;
                }
            })
            .fail(function (xhr) {
                if (xhr.status === 400) {
                    const response = JSON.parse(xhr.responseText);
                    if (response.type === 'validation') {
                        const errors = response.errors;
                        for (let x in errors) {
                            const message = `<div class="field-error-msg">${errors[x].join(' ')}</div>`;
                            $(`[name=${x}`).parents('label').prepend(DOMPurify.sanitize(message));
                        }
                    } else if (response.type === 'trial' || response.type === 'instance') {
                        form.prepend(DOMPurify.sanitize(`<div class="aero-error-box"><ul><li>${response.message}</li></ul></div>`));
                    } else {
                        form.prepend(DOMPurify.sanitize(`<div class="aero-error-box"><ul><li>${Lang.errorhappened}</li></ul></div>`));
                    }
                    grecaptcha.reset();
                    $(window).scrollTop(0);
                }
            });

        return false;
    }
}
